define('blocks/../../common/js/ga',['require','exports','module'],function(require, exports, module) {
    var clientId = null;
    var getUserIdTimeout;
    var getUserIdPromise;
    var clientIdTimeout = 1000;

    function ga() {
        (window.ga || function() {}).apply(this, arguments);
    }

    if (window.ga) {
        window.ga('create', 'G-3354K9X74X');
    }

    function getUserId() {
        if (!getUserIdPromise) {
            getUserIdPromise = new Promise(function(resolve) {
                if (typeof clientId === 'string' || window.GA_ERROR) {
                    resolve(clientId);
                } else {
                    clearTimeout(getUserIdTimeout);

                    ga(function(tracker) {
                        clearTimeout(getUserIdTimeout);
                        clientId = tracker.get('clientId');
                        resolve(clientId);
                    });

                    getUserIdTimeout = setTimeout(function() {
                        resolve(clientId);
                    }, clientIdTimeout);
                }
            }).then(function(clientId) {
                getUserIdPromise = null;
                return clientId;
            });
        }

        return getUserIdPromise;
    }

    module.exports = {
        getUserId: getUserId,
        ga: ga
    };
});

